<template>
  <div class="footer_wrapper wrapper_box">
    <div class="footer_wrapper_content">
      <!-- 联系方式 -->
      <div class="contactInformation">
        <img class="logo" src="@assets/image/footer/logo.png" alt="" />
        <div class="telephone">010-59307070</div>
        <div class="telephoneText">全国业务咨询热线</div>
        <div class="address">
          公司地址：北京市西城区裕民东路3号京版信息港6层
        </div>
      </div>
      <div class="footer_wrapper_right">
        <!-- 解决方案 -->
        <div class="footer_solution">
          <div class="footer_title">解决方案</div>
          <ul class="footerNavText">
            <li v-for="(item, index) in solutionList" :key="index">
              <router-link target="_blank" :to="{ path: `solutionDetails?id=${index}` }">
                {{ item.name }}
              </router-link>
            </li>
          </ul>
        </div>
        <!-- 软件产品 -->
        <div class="footer_product">
          <div class="footer_title">软件产品</div>
          <div class="footer_productList">
            <ul
              class="footerNavText"
              v-for="(item, index) in productList"
              :key="index"
            >
              <li v-for="(itemNav, indexNav) in item" :key="indexNav">
                <router-link target="_blank" :to="{ path: `productDetails?id=${itemNav.id}` }">
                  {{ itemNav.name }}
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="footer_WeChat">
          <div class="footer_title" style="padding-left: 6px">微信公众号</div>
          <img src="@assets/image/footer/qrCode.png" alt="" />
        </div>
      </div>
    </div>
    <!-- icp备案 -->
    <div class="footer_icp">
      <div>
        版权所有© 1998 - 2022 首都信息发展股份有限公司 京ICP备05007187号-8
      </div>
      <div>
        友情链接：
        <a href="https://www.capinfo.com.cn/" target="_blank">首都信息</a> |
        <a href="https://www.aike8.com.cn/citrn/index.jsp" target="_blank"
          >首信学院</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'footerName',
  components: {},
  data() {
    return {
      solutionList: [
        { name: '部委、各级党政机关单位解决方案' },
        { name: '省(市)委组织部干部(公务员)一体化解决方案' },
        { name: '国有企事业单位解决方案' },
        { name: '纪检监察系统解决方案' },
      ],
      productList: [
        [
          {
            name: '干部信息管理平台',
            id: 0,
          },
          {
            name: '智慧党建平台',
            id: 3,
          },
          {
            name: '大数据分析平台',
            id: 6,
          },
          {
            name: '上会管理系统',
            id: 9,
          },
        ],
        [
          {
            name: '工资管理系统',
            id: 2,
          },
          {
            name: '民主测评系统',
            id: 4,
          },
          {
            name: '业务审批管理平台',
            id: 7,
          },
          {
            name: '人员PAD查询平台',
            id: 5,
          },
        ],
        [
          {
            name: '综合人事服务平台',
            id: 1,
          },
          {
            name: '统计上报汇总管理平台',
            id: 10,
          },
          {
            name: '人才综合管理服务平台',
            id: 8,
          },
          {
            name: '公务员信息采集统计上报一体机',
            id: 11,
          },
        ],
      ],
    }
  },
  watch: {},
  methods: {},
  created() {},
  mounted() {},
}
</script>

<style lang='scss' scope>
.footer_wrapper {
  padding-top: 112px;
  width: 100%;
  .footer_wrapper_content {
    display: flex;
    justify-content: space-between;
    height: 230px;
    // 联系方式
    .contactInformation {
      color: $color-text-primary;
      .logo {
        width: 370px;
        margin-bottom: 32px;
      }
      .telephone {
        font-size: $font-size-22;
        line-height: 24px;
        font-weight: bold;
      }
      .telephoneText,
      .address {
        font-size: $font-size-12;
        line-height: 24px;
      }
      .address {
        padding-top: 14px;
      }
    }
    .footer_wrapper_right {
      display: flex;
    }
    // 解决方案
    .footer_solution {
      // width: 320px;
    }
    // 软件产品
    .footer_productList {
      display: flex;
    }
    // 微信公众号
    .footer_WeChat {
      img {
        display: block;
        width: 145px;
      }
    }
    .footer_title {
      font-size: 18px;
      color: $color-text-primary;
      font-weight: bold;
      padding-bottom: 24px;
    }
    .footerNavText {
      padding-right: 60px;
      li {
        font-size: $font-size-12;
        line-height: 36px;
      }
    }
  }
  // icp备案
  .footer_icp {
    border-top: 1px solid $border-color-base;
    padding: 50px 0;
    text-align: center;
    font-size: $font-size-12;
    color: $color-text-regular;
    line-height: 32px;
  }
}
@media screen and (max-width: 1640px) {
  /*版心居中*/
  .footerNavText {
    padding-right: 30px !important;
  }
}
</style>